export function isRecordPage(): boolean {
    const pageInfo = document.getElementById("page-info");
    if (!pageInfo) return false;
    return pageInfo.dataset.pageType === "RecordPage";
}

(window as any).isRecordPage = isRecordPage;